import React, { Fragment, useState } from "react";
import {
  Card,
  CardContent,
  CardActions,
  TextField,
  FormControl,
} from "@material-ui/core";
import Button from "components/CustomButtons/Button";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import loaderIcon from "assets/img/loader.gif";
import SimpleReactValidator from "simple-react-validator";
import Select from "react-select";

const validationStyle = {
  color: "red",
};

const validator = new SimpleReactValidator();

const adminRoles = [
  { label: "Admin Main", value: "Admin Main" },
  { label: "Sub-admin", value: "Sub-admin" },
  { label: "Event Manager", value: "Event Manager" },
  { label: "Webinar Manager", value: "Webinar Manager" },
  { label: "Static Content editor", value: "Static Content editor" },
  { label: "Operation manager", value: "Operation manager" },
  { label: "Finance manager", value: "Finance manager" },
];

function AddAdmin() {
  const [state, setState] = useState({
    name: "",
    email: "",
    mobile: "",
    role: "",
  });

  const loading = false;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  const handleSelect = (value) => {
    setState({ ...state, role: value });
  };

  const handleSubmit = () => {
    // console.log(state);
  };

  return (
    <div>
      <Card style={{ overflow: "visible" }}>
        {loading ? (
          <div className="loader_icon">
            <img src={loaderIcon} />
          </div>
        ) : (
          <Fragment>
            <CardContent>
              <form>
                <GridContainer>
                  <GridItem md={12}>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="name"
                      name="name"
                      label="Name*"
                      type="text"
                      fullWidth
                      value={state.name}
                      onChange={handleChange}
                    />
                    <TextField
                      autoFocus
                      margin="dense"
                      id="email"
                      name="email"
                      label="E-mail*"
                      type="email"
                      fullWidth
                      value={state.email}
                      onChange={handleChange}
                    />
                    <TextField
                      autoFocus
                      margin="dense"
                      id="mobile"
                      name="mobile"
                      label="Mobile*"
                      type="number"
                      fullWidth
                      value={state.mobile}
                      onChange={handleChange}
                    />
                    <FormControl fullWidth style={{ margin: "0.7rem 0" }}>
                      <legend style={{ fontSize: "1rem" }}>Admin Role</legend>
                      <Select
                        name="role"
                        options={adminRoles}
                        value={state.role}
                        onChange={handleSelect}
                        className="basic-multi-select"
                        classNamePrefix="select"
                      />
                    </FormControl>
                  </GridItem>
                  <GridItem md={12}></GridItem>
                </GridContainer>
              </form>
            </CardContent>
            <CardActions style={{ float: "right" }}>
              <Button variant="contained" color="iseas" onClick={handleSubmit}>
                Create
              </Button>
            </CardActions>
          </Fragment>
        )}
      </Card>
    </div>
  );
}

// {
//   <span style={validationStyle}>
//     {validator.message(
//       "name",
//       state.name,
//       "required|min:3|max:35"
//     )}
//   </span>
// }

export default AddAdmin;



// WEBPACK FOOTER //
// ./src/views/ISEAS/AdminManagement/AddAdmin.js